import { render, staticRenderFns } from "./SQuesTwentyEight.vue?vue&type=template&id=07ef446a&"
import script from "./SQuesTwentyEight.vue?vue&type=script&lang=js&"
export * from "./SQuesTwentyEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports